// src/components/About.js
import React from 'react';
import '../styles/About.css';
import oldbvmtrucks from '../assets/oldboultbeetrucks.jpg';
import oldbvmtrucksWebp from '../assets/oldboultbeetrucks.webp';
import innovationandtechnology from '../assets/innovationandtech.jpg';
import innovationandtechnologyWebp from '../assets/innovationandtech.webp';
import aboutCertification from '../assets/about-certification.jpg';
import Section from './Section.js';
import AnimateOnScroll from './AnimateOnScroll.js';
import DynamicBackground from './DynamicBackground.js';
import { Helmet } from 'react-helmet-async';

const About = () => {
    return (
    <div className='bg-custom-earth'>
        <DynamicBackground>
        <Helmet>
            <title>About Boultbee | 40+ Years Vegetation Management BC</title>
            <meta name="description" content="BC's most experienced industrial herbicide applicator. Avetta certified, IVMA member, WorkSafeBC compliant. Learn about our heritage and technology." />
            <link rel="canonical" href="https://www.weedmanager.com/about-us" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Boultbee Vegetation Management" />
            <meta property="og:title" content="About Boultbee | 40+ Years Vegetation Management BC" />
            <meta property="og:description" content="BC's most experienced industrial herbicide applicator. Avetta certified, IVMA member, WorkSafeBC compliant. Learn about our heritage and technology." />
            <meta property="og:url" content="https://www.weedmanager.com/about-us" />
            <meta property="og:image" content="https://www.weedmanager.com/images/og-about.jpg" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="About Boultbee | 40+ Years Vegetation Management BC" />
            <meta name="twitter:description" content="BC's most experienced industrial herbicide applicator. Avetta certified, IVMA member, WorkSafeBC compliant. Learn about our heritage and technology." />
            <meta name="twitter:image" content="https://www.weedmanager.com/images/og-about.jpg" />
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.weedmanager.com/" },
                  { "@type": "ListItem", "position": 2, "name": "About Us", "item": "https://www.weedmanager.com/about-us" }
                ]
              })}
            </script>
        </Helmet>

            <div className="aboutushero relative bg-no-repeat bg-center md:bg-cover flex flex-col justify-end parallax">
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.15), rgba(0,0,0,0.35))' }}></div>
              <div className="relative z-10 text-center pb-16 px-4">
                <h1 className="text-3xl md:text-5xl font-bold text-white drop-shadow-lg">Boultbee Vegetation Management</h1>
                <p className="text-lg md:text-2xl text-gray-300 mt-3 font-medium">Trusted Industrial Herbicide Applicators Since 1984</p>
              </div>
            </div>

        <div className="min-h-screen flex flex-col">
       

          {/* Heritage Section */}
          <AnimateOnScroll animation="fade-in-right">
          <Section
            heading="Four Decades. One Standard of Excellence."
            paragraph="Founded in Penticton, BC, Boultbee Vegetation Management has become one of British Columbia's most trusted industrial herbicide applicators. What began as a regional vegetation management operation has grown to serve industrial, utility, and municipal clients across most of British Columbia. Our longevity reflects a consistent commitment to doing the job right: using the right herbicide at the right rate in the right place at the right time."
            imgSrc={oldbvmtrucks}
            webpSrc={oldbvmtrucksWebp}
            altText="Historic Boultbee Vegetation Management fleet vehicles from the company's early years in Penticton BC"
            imgWidth={600}
            imgHeight={404}
          />
          </AnimateOnScroll>

          {/* Technology Section */}
          <AnimateOnScroll animation="fade-in-left">
          <Section
            heading="Technology-Driven Precision Application"
            paragraph="Boultbee has long adopted technology that improves herbicide application accuracy, documentation, and environmental performance. On-board GPS tracking ensures precise coverage, and flow control systems deliver consistent herbicide rates regardless of vehicle speed or terrain. Variable analysis optimizes herbicide selection, application rates, and timing for maximum efficacy with minimum product usage. InjectorTech precision injection technology enables on-the-fly herbicide mixing adjustments to respond to changing vegetation conditions during application."
            imgSrc={innovationandtechnology}
            webpSrc={innovationandtechnologyWebp}
            altText="Boultbee GPS-tracked herbicide application technology and flow control systems"
            imgWidth={512}
            imgHeight={512}
          />
          </AnimateOnScroll>

          {/* Certification Section */}
          <AnimateOnScroll animation="fade-in-right">
          <Section
            heading="Certified, Trained, and Continuously Improving"
            paragraph="Every Boultbee technician holds a current BC Industrial Vegetation and Noxious Weed Pesticide Applicator Certificate, maintained through ongoing recertification and continuing education credits administered through IVMA. Our team participates in industry conferences, training programs, and safety certification updates to ensure we remain at the leading edge of vegetation management science and practice."
            imgSrc={aboutCertification}
            altText="Boultbee technician training and BC pesticide applicator certification"
            imgWidth={1200}
            imgHeight={630}
          />
          </AnimateOnScroll>


        </div>
        </DynamicBackground>
    </div>
  );
}

export default About;
